// extracted by mini-css-extract-plugin
export default {"liked":"LikedSong_liked__zLTYh","liked_close":"LikedSong_liked_close__FSp9d"};